<mat-sidenav-container class="sidenav-container mat-app-background">

    <mat-toolbar id="toolbar">
        <a class="navbar-brand" href="#">
            <img src="assets/img/logo.svg" />
        </a>

        <span class="spacer"></span>



        <button mat-icon-button (click)="confirmDialog()">
            <mat-icon>logout</mat-icon>
        </button>



    </mat-toolbar>

    <router-outlet></router-outlet>

</mat-sidenav-container>